module.exports = __webpack_public_path__ + "static/media/greeting_card_2.7503119c.png";